<template>
  <span
    class="tw-whitespace-nowrap"
    :style="style"
  >
    {{ text }}
  </span>
</template>

<script>
import { mapState } from 'pinia';
import {
  dataNotAvailable,
  formatElevationRounded,
  getAlertColorForeground,
} from '@@/utils/CommonUtils';
import { useMetaStore } from '@@/stores/Meta';
import { useUserStore } from '@@/stores/User';

/**
 * @todo Display locked down view for free users.
 */
export default {
  name: 'SnowLevel',

  props: {
    forecast: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    showUnits: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState(useMetaStore, ['getSnowLevelAlert', 'location_types']),
    ...mapState(useUserStore, { units: (state) => state.preferences.units }),

    snowLevel() {
      return this.forecast.snow_level;
    },

    snowLevelElevation() {
      return formatElevationRounded(this.snowLevel, this.units);
    },

    snowLevelElevationNoUnits() {
      return this.snowLevelElevation.replace(/ m$/, '').replace(/ ft$/, '');
    },

    style() {
      const snowLevelAlert = this.getSnowLevelAlert(this.forecast.alerts);
      return { color: getAlertColorForeground(snowLevelAlert) };
    },

    text() {
      if (typeof this.snowLevel === 'number') {
        return this.showUnits ? this.snowLevelElevation : this.snowLevelElevationNoUnits;
      }

      return dataNotAvailable;
    },
  },
};
</script>
